import * as React from 'react';
import axios from 'axios';
import { Select } from 'antd';
import { url } from '../../../config/config';

interface IHeurekaCategory {
  id: number;
  category: string;
}

interface IHeurekaSelectCategoryProps {
  name: string;
  value: string | null;
  placeholder?: string;
  onChange: Function;
}

interface IHeurekaSelectCategoryState {
  searchHeurekaCategory: IHeurekaCategory[];
}

class HeurekaSelectCategory extends React.Component<IHeurekaSelectCategoryProps, IHeurekaSelectCategoryState> {

  // kompletní seznam kategorií
  private heurekaCategories: any = null;

  constructor(props: IHeurekaSelectCategoryProps) {
    super(props);

    this.onSearchHeurekaCategory = this.onSearchHeurekaCategory.bind(this);

    this.state = {
      searchHeurekaCategory: [],
    };
  }

  public componentDidMount() {
    if (!this.heurekaCategories) {
      axios.post(`${url}/categories/heureka-categories`)
        .then((request) => request.data)
        .then((response) => {
          this.heurekaCategories = response;
        });
    }
  }

  public render() {
    return (
      <Select
        style={{ width: '100%' }}
        showSearch={true}
        onChange={(value: string) => this.props.onChange({ target: { name: this.props.name, value } })}
        placeholder={this.props.placeholder}
        defaultValue={(this.props.value || true).toString()}
        defaultActiveFirstOption={false}
        value={(this.props.value || '').toString()}
        onSearch={this.onSearchHeurekaCategory}
        notFoundContent={null}
        showArrow={false}
        filterOption={false}
      >
        {this.state.searchHeurekaCategory.map((c: IHeurekaCategory) => (
          <Select.Option value={this.props.value ? this.props.value : ''} key={c.category}>{c.category}</Select.Option>
        ))}
      </Select>
    );
  }

  /**
   * Vyhledávání v kategoriích heuréky
   *
   * @param searchQuery
   */
  private onSearchHeurekaCategory(searchQuery: any) {
    const searched: IHeurekaCategory[] = [];

    if (searchQuery.length >= 2) {
      this.heurekaCategories.every((c: IHeurekaCategory) => {
        if (c.category.toLocaleLowerCase().search(searchQuery.toLocaleLowerCase()) >= 0) {
          searched.push(c);
        }
        return (searched.length < 20);
      });
    }

    this.setState({
      searchHeurekaCategory: searched,
    });
  }
}

export default HeurekaSelectCategory;


// WEBPACK FOOTER //
// ./src/modules/Heureka/SelectCategory/SelectCategory.tsx